<template>
  <v-card flat tile>
    <v-container class="secondary lighten-1 white--text pb-6" v-if="register_step===1">
      <v-card-text class="text-center">{{$store.state.website.register_description}}</v-card-text>
      <v-row justify="center">
        <v-btn tile class="mr-2" @click="loadFacebook">
          <v-icon class="mr-2" :color="$helpers.linkColor('facebook')">fab fa-facebook</v-icon>Facebook
        </v-btn>
        <v-btn tile class="ml-2" @click="loadGoogle">
          <v-img style="height:24px;width:23px" class="mr-2" src="/google.png" />Google
        </v-btn>
      </v-row>
    </v-container>

    <v-container v-if="register_step===1">
      <h4 class="text-center mb-4 mt-2 grey--text text--darken-3">Sign up</h4>
      <v-form ref="register-form" lazy-validation v-on:keyup.enter="Validate">
        <v-row justify="center">
          <v-col cols="10" md="10" class="py-0">
            <v-text-field
              outlined
              v-model="register.name"
              label="Name"
              clearable
              :rules="[rules.required,rules.name]"
              :validate-on-blur="true"
            ></v-text-field>
          </v-col>
          <v-col cols="10" md="10" class="py-0">
            <v-text-field
              outlined
              v-model="register.email"
              label="Email"
              inputmode="email"
              type="email"
              clearable
              :rules="[rules.required,rules.email]"
              :validate-on-blur="true"
            ></v-text-field>
          </v-col>
          <v-col cols="10" sm="5" md="5" class="py-0">
            <v-text-field
              outlined
              v-model="register.password"
              @change="register.password_c=''"
              type="password"
              label="Password"
              :rules="[rules.required,rules.min,rules.password]"
              clearable
              :validate-on-blur="true"
            ></v-text-field>
          </v-col>
          <v-col cols="10" sm="5" md="5" class="py-0">
            <v-text-field
              outlined
              v-model="register.password_c"
              type="password"
              label="Confirm Password"
              clearable
              hint
              :rules="[rules.required,rules.match_password]"
              :validate-on-blur="true"
            ></v-text-field>
          </v-col>
          <v-col cols="10" md="10" class="py-0">
            <vue-phone-number-input
              v-model="phone_raw"
              :show-code-on-list="false"
              @update="setPhone"
              required
              size="lg"
              :preferred-countries="['CA','US','AU','GB']"
            ></vue-phone-number-input>
          </v-col>
          <v-col cols="12" md="10" class="mt-2 text-center" v-if="error">
            <v-alert type="error">{{error}}</v-alert>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-container v-if="register_step===2">
      <h4 class="text-center mb-4 mt-2 grey--text">Phone Verification</h4>
      <v-form ref="verify-form" lazy-validation onsubmit="return false;">
        <v-row justify="center">
          <v-col cols="10" md="8" class="py-0">
            <v-text-field
              outlined
              v-on:keyup.enter="submitRegistration"
              v-model="register.sms_code"
              label="Please enter 4 digit code"
              type="tel"
              v-mask="'####'"
              :rules="[rules.required,rules.code]"
              :validate-on-blur="true"
              prepend-inner-icon="fa-key"
              clearable
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-card-text class="pt-0 text-center" v-if="register_step===1 || register_step===2">
      <span>
        By clicking "Sign Up", you agree to our
        <router-link to="/terms" target="_blank">terms</router-link>. We’ll occasionally send you account related emails.
      </span>
    </v-card-text>

    <v-card-actions class="grey lighten-3">
      <v-btn icon to="/">
        <v-icon>fa-home</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        v-if="register_step===0"
        @click="register_step=1"
        :disabled="!register.membership_type"
      >Next</v-btn>
      <v-btn text v-if="register_step===2" @click="register_step=1">Back</v-btn>

      <v-btn color="primary" @click="Validate" :loading="loading" v-if="register_step===1">Sign Up</v-btn>
      <v-btn
        color="primary"
        @click="submitRegistration"
        :loading="loading"
        v-if="register_step===2"
      >Sign Up</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mask } from "vue-the-mask";

export default {
  directives: {
    mask
  },
  name: "",
  data: () => ({
    error: "",
    loading: false,
    register_step: 1,
    phone_raw: "",
    register: {
      sms_code: "",
      sms_id: "",
      email: "",
      name: "",
      password: "",
      password_c: "",
      phone: "",
      membership_type: "standard"
    }
  }),
  created() {
    if (this.$route.query.membership) {
      if (["standard", "plus", "pro"].includes(this.$route.query.membership)) {
        this.register.membership_type = this.$route.query.membership;
      }
    }
  },
  methods: {
    setPhone(ew) {
      console.log(ew);
      console.log("ew.countryCode", ew.countryCode);
      this.register.phone = ew.e164;
    },
    loadGoogle() {
      let self = this;
      this.$google.signIn(
        function(googleUser) {
          let token = googleUser.getAuthResponse().id_token;
          self.googleLogin(token);
        },
        function(error) {
          this.error = error;
        }
      );
    },
    async googleLogin(token) {
      try {
        this.loading = true;
        await this.$store.dispatch("google_login", token);
      } catch (ex) {
        this.error = ex.error;
      }
      this.loading = false;
    },
    loadFacebook() {
      let self = this;
      window.FB.login(
        res => {
          if (res.status === "connected") {
            self.facebookLogin(res);
          }
        },
        {
          scope: "public_profile,email"
        }
      );
    },
    async facebookLogin(response) {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "facebook_login",
          response.authResponse.accessToken
        );
      } catch (ex) {
        this.error = ex.error;
      }
      this.loading = false;
    },
    async submitRegistration() {
      //Submit registration to server.
      if (!this.$refs["verify-form"].validate()) {
        return;
      }
      this.loading = true;
      try {
        let registration = await this.$api.post(`/register`, {
          email: this.register.email,
          password: this.register.password,
          name: this.register.name,
          sms_id: this.register.sms_id,
          sms_code: this.register.sms_code,
          membership_type: this.register.membership_type
        });
        this.$store.commit("set_token", registration.token);
        await this.$store.dispatch("loadUser");
        this.$router.push("/welcome");
        this.error = "";
      } catch (ex) {
        this.error = ex.error;
        this.register_step = 1;
      }
      this.loading = false;
    },
    async Validate() {
      if (!this.$refs["register-form"].validate()) {
        return;
      }
      this.loading = true;
      try {
        this.register.sms_code = "";
        this.register.sms_id = await this.$api.post(`/verify`, {
          number: this.register.phone,
          email: this.register.email
        });
        this.error = "";
        this.register_step = 2;
      } catch (ex) {
        this.error = ex.error;
      }
      this.loading = false;
    }
  },
  computed: {
    rules() {
      return {
        ...this.$helpers.rules,
        match_password: value => {
          if (!value) {
            return false;
          }
          if (this.register.password !== this.register.password_c) {
            return "Passwords dont match";
          }
        }
      };
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
